import CardUsuario from './CardUsuario'

export default CardUsuario